import { noGiftCardsOnNotFound } from '@/helpers/gift-card';
import { get, handleError } from '@/lib/http-adapter';
import type { GiftCard } from '@/state/gift-cards';

// Only ACTIVE and PUBLIC gift cards; the backend filters, unlike packs.
export const getGiftCards = async () => {
  try {
    const response = await get<{ gift_cards: GiftCard[] }>(
      '/public/gift-cards'
    ).catch(noGiftCardsOnNotFound);
    return response?.gift_cards;
  } catch (error) {
    handleError(error);
  }
};

// A PRIVATE gift card resolves here too: it is sold off a direct link.
export const getGiftCardDetails = async ({ slug }: { slug: string }) => {
  try {
    const response = await get<{ gift_card: GiftCard }>(
      `/public/gift-cards/${encodeURIComponent(slug)}`
    );
    return response?.gift_card ?? null;
  } catch (error) {
    handleError(error);
  }
};
